import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Contact.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faEnvelope, faInfo, faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";
import { faStairs } from "@fortawesome/free-solid-svg-icons/faStairs";


const Contact = () => {

  return(
    
    <div className="envelope-contact">
  
  
  <div className="container-wrap">

    
  <div className="">
    <div  className="grid-container-contact">
    <div className="grid-item-contact">
      <div className="icon-contact">
        <FontAwesomeIcon  className="contact-icon" icon={faEnvelope}/>
      
      </div>
      <div className="contact-text-wrap">
      <p className="contact-text">     Pour nous contacter: 
      <br></br>
      <div className="endereco-email">
        <p>        aloha@multi-learn.org
        </p>

      </div>

            </p>

      </div>
      

        </div>
 
        <div className="grid-item-contact">
        <div className="icon-contact">
        <FontAwesomeIcon  className="contact-icon" icon={faStairs}/>
      
      </div>
        <div className="contact-text-wrap">
        <p className="contact-text">
                  
          Nos autres projets en cours et passés: 
          <br></br>

          <a href="https://multi-learn.org/" target="_blank" rel="noopener noreferrer" > www.multi-learn.org</a>


          </p>
          </div>
</div>
 <div className="grid-item-contact">
      <div className="icon-contact">
        <FontAwesomeIcon  className="contact-icon" icon={faInfo}/>
      
      </div>
      <div className="contact-text-wrap">
      <p className="contact-text">
            
          Politique de confidentialité du site: 
          <br></br>
          <a href="/politique-de-confidentialite">Politique de Confidentialité</a>


          </p>

      </div>
      

        </div>
</div>
       </div>

  </div>
     
             
        
         

  


           

            

   
    

</div>


    
  );

/*   const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
  };

  return (
    <div>
      <h2>Carousel Component</h2>
      <Slider {...settings}>
        <div>
          <h3>FIRST SLIDE</h3>
        </div>
        <div>
          <h3>SECOND SLIDE</h3>
        </div>
        <div>
          <h3>THIRD SLIDE</h3>
        </div>
        <div>
          <h3>FORTH SLIDE</h3>
        </div>
      </Slider>
    </div>
  ); */
};

export default Contact;